<template>
    <modal-crud
        title="Nova Aplicação"
        v-on:close="$emit('close')"
        :isLoading="isLoading">
        
        <section class="modal-card-body">
            <!-- Campo Nome -->
            <b-field label="Nome">
                <b-input
                    type="text"
                    placeholder="Nome"
                    v-model="application_name"
                    required>
                </b-input>
            </b-field>

            <!-- Campo MFA Ativado -->
            <b-field label="MFA Ativado">
                <b-switch
                    v-model="mfa_ativado"
                    type="is-success"
                    passive-type="is-danger"
                    true-value="1"
                    false-value="0"
                >
                    {{ mfa_ativado === '1' ? 'Ativado' : 'Desativado' }}
                </b-switch>
            </b-field>
        </section>

        <!-- Botões -->
        <div slot="buttons">
            <b-button
                label="Salvar"
                type="is-primary"
                @click="save" />
        </div>
    </modal-crud>
</template>


<script>
import { Component, Vue } from 'vue-property-decorator';
import ModalCrud from '@/components/Layout/ModalCrud.vue';
import state from '@/modules/auth/store/state';
import services from '@/http';

@Component({
    components: {
        "modal-crud": ModalCrud,
    },
})

export default class Create extends Vue {
    data() {
        return {
            application_name: null,
            mfa_ativado: '0', // Valor inicial como desativado (string '0')
            isLoading: false
        }
    }

    save() {
        const data = {
            application_name: this.application_name,
            mfa_ativado: this.mfa_ativado,
            userId: state.user.id
        };

        this.isLoading = true;

        services.application.register(data)
            .then(res => {
                this.$root.flashSuccess('Adicionado com sucesso!');
                this.$emit('close');
                this.$emit('refreshList');
            })
            .catch(err => {
                this.$root.flashError(err);
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
</script>
